import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorActiveTaxWithholdingAccount = (
  internalAccount: bankingApiSpec.InternalAccount
) =>
  internalAccount.type === "TaxWithholding" &&
  internalAccount.status === "Active";
